window.queryData = window.queryData || {};
window.queryData.verifyRecoveryFactorQuery = `query verifyRecoveryFactor($args_RecoveryFactorsInput: RecoveryFactorsInput) {
    verifyRecoveryFactor(input: $args_RecoveryFactorsInput) {
    __typename
    ... on SuccessResponse {
      id
      message
      status
    }
    ... on ErrorResponse {
      correlationId
      errorCode
      issues {
        field
        issue
        code
        message
      }
      legacyError
      message
      name
      priority
      stack
    }
    }
    }
    `

window.queryData.resendRecoveryFactoryQuery = `query resendRecoveryFactor($args_ResendRecoveryFactorInput: SenderInput) {
    resendRecoveryFactor(input: $args_ResendRecoveryFactorInput) {
    __typename
    ... on sendRecoveryFactorResponse {
      redirectionError {
        code
        message
        countryCode
      }
      factor {
        id
        factorType
        factorValue
        factorStatus
      }
      msg: message
      status
    }
    ... on ErrorResponse {
      correlationId
      errorCode
      issues {
        field
        issue
        code
        message
      }
      legacyError
      message
      name
      priority
      stack
    }
    }
    }
    `
    ;
